import { createAsyncThunk } from '@reduxjs/toolkit';

import { updateBusinessesPersonsXrefs } from 'services/businesses';
import { getBusinessesId } from 'utils/authService';
import { getEnumKeyByValue } from 'utils/helpers';
import { ProfileState } from 'entities/profile';
import { RootState } from 'state/reducers';
import {
  searchBusinessesProductsXrefs,
  updateBusinessesProductsXrefs,
} from 'services/businessProducts';
import {
  ProductStatuses,
  ProductTypeCodes,
  ProgressState,
} from 'entities/progress';

import { updateProductById } from './utils';

export const fetchBusinessProducts = createAsyncThunk(
  'progress/searchBusinessesProducts',
  async () => {
    try {
      const businessesId: number = getBusinessesId();
      const data = await searchBusinessesProductsXrefs({ businessesId });

      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export const updateBusinessProduct = createAsyncThunk(
  'progress/updateBusinessesProduct',
  async (fields: any, thunkApi) => {
    try {
      const { getState } = thunkApi;

      const { profile, progress } = getState() as {
        profile: ProfileState;
        progress: ProgressState;
      };
      const { person } = profile;
      const { businessProducts } = progress;

      const updateFields = {
        ...fields,
        modifiedBy: person.emailAddress,
      };

      await updateBusinessesProductsXrefs(updateFields);
      const products = updateProductById(businessProducts, updateFields);

      const newProductType = fields.isActive
        ? getEnumKeyByValue(ProductTypeCodes, fields.productsTypeCode)
        : '';

      return {
        products,
        newProductType,
      };
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export const updateBusinessProductStatuses = createAsyncThunk(
  'progress/updateBusinessProductStatuses',
  async (status: ProductStatuses, thunkApi) => {
    try {
      const { getState } = thunkApi;

      const { profile, progress } = getState() as {
        profile: ProfileState;
        progress: ProgressState;
      };
      const { person } = profile;
      const { businessProducts } = progress;

      const capitalProduct = businessProducts.find(
        (prod) =>
          prod.productsTypeCode === ProductTypeCodes.capital && prod.isActive,
      );

      if (!capitalProduct) {
        return null;
      }

      const updateFields = {
        businessesProductsXrefId: capitalProduct.businessesProductsXrefId,
        productStatusesId: status,
        modifiedBy: person.emailAddress,
      };

      await updateBusinessesProductsXrefs(updateFields);

      const products = updateProductById(businessProducts, updateFields);
      return products;
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export const updateBusinessPersonXref = createAsyncThunk(
  'progress/updateBusinessPersonXref',
  async (_: void, thunkApi) => {
    try {
      const { getState } = thunkApi;

      const { profile } = getState() as RootState;
      const { person, businessPerson } = profile;

      const payload = {
        businessesPersonsXREFId: businessPerson.businessesPersonsXrefid,
        workingCapitalOrchestrationFirstAlertedOn: new Date().toISOString(),
        modifiedBy: person.emailAddress,
      };

      await updateBusinessesPersonsXrefs(payload);

      return payload;
    } catch (e) {
      return Promise.reject(e);
    }
  },
);
